import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewSubjectType, toggleSubjectType, deleteSubjectType } from '~/services/api'
import { SubjectTypeDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    subject_type: Array,
    data: Array,
    loading: Boolean,
}

export class AbstractSubjectTypeViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            subject_type: [
                {
                    subject_type: {
                        field: 'text',
                        translate: "classes:subject-type.title",
                        route: false,
                        sortable: true,
                    },
                    code: {
                        field: 'text',
                        translate: "classes:subject-type.add.codeLabel",
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        translate: "status",
                        route: false,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        translate: "classes:subject-type.action",
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this._handleChange = this._handleChange.bind(this)
        this.toggle = this.toggle.bind(this)
        this.delSubjectType = this.delSubjectType.bind(this)
    }

    componentDidMount() {
        this.loadSubjectType()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        toggleSubjectType(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadSubjectType()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    delSubjectType(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        deleteSubjectType(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadSubjectType()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadSubjectType() {
        this._handleChange('loading', true)
        viewSubjectType(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let subject_type = []
            subject_type.push(this.state.subject_type[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.subjectType.map((item, index) => {
                    const data: SubjectTypeDTO = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            translate: "statusActive",
                            badge: 'table-green',
                            modal: 'modal_class_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            translate: "statusInactive",
                            badge: 'table-red',
                            modal: 'modal_class_' + index,
                        }
                    }
                    const tableData = {
                        subject_type: {
                            text: data.name,
                        },
                        code: {
                            text: data.code,
                        },
                        status: text,
                        action: {
                            text: 'Edit',
                            translate: "EditBtn",
                            route: route.admin.school.subject_type.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    subject_type.push(tableData)
                })
            } else {
                toastMessage('error', response.message)
            }
            this.setState({
                data: dataList,
                subject_type,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
